import { WebSocketConfig } from './types';

export const WS_APP_SUBPROTOCOL = 'mcv.ws.v1';
export const WS_BEARER_SUBPROTOCOL_PREFIX = 'bearer.';

export const PRIVATE_WEBSOCKET_CONFIG: WebSocketConfig = {
  endpoint: '/ws',
  eventNamespace: 'private-ws',
  reconnectDelay: 3000,
  maxReconnectAttempts: 5,
  heartbeatEnabled: true,
};
